import { c as _c } from "react/compiler-runtime";
import { NumericRange } from '@/types/range';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { FAQs as SEOFAQs } from '@/components/seo/FAQs';
import type { FAQItemType } from '@/components/seo/FAQs';
import { Link } from '@/components/links';
import { SectionHeadline } from '@/components/SectionHeadline';
const FAQsSection = t0 => {
  const $ = _c(8);
  const {
    data,
    title,
    anchorKey
  } = t0;
  let t1;
  if ($[0] !== anchorKey || $[1] !== title) {
    t1 = <SectionHeadline anchorKey={anchorKey}>{title}</SectionHeadline>;
    $[0] = anchorKey;
    $[1] = title;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== data) {
    t2 = <SEOFAQs data={data} hideButton={true} className="mx-auto mt-12 max-w-192 lg:mt-16" />;
    $[3] = data;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t1 || $[6] !== t2) {
    t3 = <div className="pb-20 lg:pb-40">{t1}{t2}</div>;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};
function FAQs() {
  const $ = _c(17);
  const {
    t
  } = useTranslation("exchangeRate");
  let t0;
  if ($[0] !== t) {
    t0 = Array.from({
      length: 4
    }, (_, index) => {
      const faqIndex = index + 1 as NumericRange<1, 4>;
      return {
        question: t(`faqSections.1.faqs.${faqIndex}.question`),
        answer: faqIndex === 3 ? <Trans t={t} i18nKey={`faqSections.1.faqs.${faqIndex}.answer`}><Link testId="exchangeRateFAQs1Answer3" analyticsParam="exchangeRateFAQs1Answer3" to="https://skippay.cz/blog/slovnik-pojmupismeno-k/kurzovni-listek/" /></Trans> : faqIndex === 4 ? <Trans t={t} i18nKey={`faqSections.1.faqs.${faqIndex}.answer`}><Link testId="exchangeRateFAQs1Answer2" analyticsParam="exchangeRateFAQs1Answer2" to="https://skippay.cz/blog/slovnik-pojmupismeno-d/dynamic-currency-conversion/" /></Trans> : t(`faqSections.1.faqs.${faqIndex}.answer`)
      };
    });
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const faqs1Data = t0;
  let t1;
  if ($[2] !== t) {
    t1 = Array.from({
      length: 4
    }, (__0, index_0) => {
      const faqIndex_0 = index_0 + 1 as NumericRange<1, 4>;
      return {
        question: t(`faqSections.2.faqs.${faqIndex_0}.question`),
        answer: faqIndex_0 === 1 ? <Trans t={t} i18nKey={`faqSections.2.faqs.${faqIndex_0}.answer`}><Link testId="exchangeRateFAQs2Answer1" analyticsParam="exchangeRateFAQs2Answer1" to="https://skippay.cz/blog/slovnik-pojmupismeno-m/menovy-kurz/" /></Trans> : faqIndex_0 === 2 ? <Trans t={t} i18nKey={`faqSections.2.faqs.${faqIndex_0}.answer`}><Link testId="exchangeRateFAQs2Answer2" analyticsParam="exchangeRateFAQs2Answer2" to="https://skippay.cz/blog/slovnik-pojmupismeno-k/kurz-nakup/" /></Trans> : faqIndex_0 === 3 ? <Trans t={t} i18nKey={`faqSections.2.faqs.${faqIndex_0}.answer`}><Link testId="exchangeRateFAQs2Answer3" analyticsParam="exchangeRateFAQs2Answer3" to="https://skippay.cz/blog/slovnik-pojmupismeno-k/kurz-prodej/" /></Trans> : <Trans t={t} i18nKey={`faqSections.2.faqs.${faqIndex_0}.answer`}><Link testId="exchangeRateFAQs2Answer4" analyticsParam="exchangeRateFAQs2Answer4" to="https://skippay.cz/blog/slovnik-pojmupismeno-s/stredovy-kurz/" /></Trans>
      };
    });
    $[2] = t;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const faqs2Data = t1;
  let t2;
  if ($[4] !== t) {
    t2 = t("faqSections.1.title");
    $[4] = t;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== faqs1Data || $[7] !== t2) {
    t3 = <FAQsSection data={faqs1Data} title={t2} anchorKey="faqSections.1.title" />;
    $[6] = faqs1Data;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t) {
    t4 = t("faqSections.2.title");
    $[9] = t;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== faqs2Data || $[12] !== t4) {
    t5 = <FAQsSection data={faqs2Data} title={t4} anchorKey="faqSections.2.title" />;
    $[11] = faqs2Data;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== t3 || $[15] !== t5) {
    t6 = <div className="bg-blue-50 px-4 pt-12 lg:pt-20">{t3}{t5}</div>;
    $[14] = t3;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  return t6;
}
export default FAQs;